import React from "react";
import {useTranslation} from "react-i18next";
import {Accordion, AccordionSummary, AccordionDetails} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Seo from "../../common/Seo";
import Footer from "../../navigation/Footer";
import {EXTERNAL_LINKS} from "../../../config/external-links";
import {FAQ_ITEMS, FAQ_INTRO} from "./faq-content";
import "./Faq.css";

// Public FAQ page. Content mirrors the published FAQ on emdrlink.pl/app/#faq.
const Faq: React.FC = () => {
    const {t} = useTranslation();
    return (
        <div className="faq-page">
            <Seo
                title={t("FAQ")}
                description={t("Frequently asked questions about the EMDRlink Online program — sessions, joining, devices, pricing and more.")}
            />
            <div className="faq-container">
                <span className="faq-badge">FAQ</span>
                <h1 className="faq-title">{FAQ_INTRO}</h1>

                <div className="faq-list">
                    {FAQ_ITEMS.map((item, i) => (
                        <Accordion
                            key={i}
                            disableGutters
                            elevation={0}
                            className="faq-item"
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`faq-${i}-content`}
                                id={`faq-${i}-header`}
                            >
                                <span className="faq-q">{item.q}</span>
                            </AccordionSummary>
                            <AccordionDetails>
                                {item.a.map((para, j) =>
                                    para.startsWith("–") ? (
                                        <p key={j} className="faq-a faq-a-list">{para}</p>
                                    ) : (
                                        <p key={j} className="faq-a">{para}</p>
                                    )
                                )}
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>

                <div className="faq-contact">
                    <span>{t("Have more questions?")}</span>{" "}
                    <a href={EXTERNAL_LINKS.contact} target="_blank" rel="noopener noreferrer">
                        {t("Contact us")}
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Faq;
